<template>
    <Layout>
        <div slot="main" class="home-bg">
            <div class="banner-container">
                <img :src="banner" alt="">
                <!-- <strong>{{bannerTitle}}</strong> -->
            </div>
            <div class="sub-page">
                <div class="block culture-block">
                    <strong class="block-title">{{cultureTitle}}</strong>
                    <i class="block-title-line"></i>
                    <div class="center culture-img">
                        <img v-for="(image, index) in cultureImg" :key="index" :src="image" alt="">
                    </div>
                </div>
            </div>
        </div>
    </layout>
</template>

<script>
import ajax from '@/utils/ajax';
import getLang from '@/utils/main/language';
import Layout from '@/views/Layout.vue';

export default {
    name: 'aboutCulturePreview',
    components: {
        Layout,
    },
    data() {
        return {
            isCn: window.localStorage.getItem('show-lang') !== 'en',
            banner: null,
            bannerTitle: '',
            lang: getLang(),
            cultureTitle: '',
            cultureImg: [],
        };
    },
    mounted() {
        const self = this;
        ajax.get('/web/common/navigate_list.json', { documentUrl: 'corp' }).then((result) => {
            this.banner = result.data.parentNavigate.navigateWebImg;
            this.bannerTitle = this.isCn ? result.data.parentNavigate.navigateCnName : result.data.parentNavigate.navigateEnName;
        }).catch(() => {});
        const getMessage = (event) => {
            console.log(event);
            if (!event.data.aboutCulturePage) return;
            const result = event.data;
            self.cultureImg = self.isCn ? result.data.cnWebImages : result.data.enWebImages;
            self.cultureImg = self.cultureImg ? self.cultureImg.split(',') : [];
            self.cultureTitle = self.isCn ? result.data.cnName : result.data.enName;
            window.removeEventListener('message', getMessage);
        };
        window.addEventListener('message', getMessage, false);
        if (window.opener) {
            window.opener.postMessage('aboutCultureReady');
        }
    },
};
</script>
<style lang="less" scoped>
    .banner-container {
        width: 100%;
        height: 400px;
        position: relative;
        img{
            width: 100%;
            height: 100%;
        }
        strong{
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            font-size: 32px;
            color: #fff;
            font-weight: 600;
        }
    }
    .block {
        margin-top: 10px;
        background: #fff;
        padding: 0 15px;
        .block-title {
            display: block;
            padding-top: 40px;
            font-size: 20px;
            font-weight: 600;
            text-align: center;
        }
        .block-title-line {
            margin-top: 12px;
            display: block;
            margin: 0 auto;
            width: 44px;
            height: 2px;
            background: #C71F4B;
        }
    }
    .center {
        width: 960px;
        margin: 20px auto;
    }
    .culture-img {
        img {
            display: block;
            margin: 10px 0;
            width: 100%;
        }
    }
</style>
